export const GRID_COLS_XL_4 =
    "grid gap-3 grid-cols-4 xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-4";
export const GRID_COLS_XL_5 =
    "grid gap-3 grid-cols-5 xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5";
